/**
 * Which Sentry environment a page load reports as.
 *
 * The live Hub (hub.thestudioldg.com) and the staging address
 * (ldg-hub-staging.netlify.app) are ONE Netlify site, one build, and that
 * build carries VITE_SENTRY_ENVIRONMENT=staging (HUB-SETUP.md). So every
 * family's error arrived in Sentry labelled staging, and "show me production"
 * showed nothing (usage analysis, 2026-10-24). The address a page is on is
 * the only thing that tells the two apart, so it decides here.
 *
 * Pure and import-free so node tests can run it directly.
 */
export const LIVE_HUB_HOST = 'hub.thestudioldg.com';

export function sentryEnvironmentFor(
  hostname: string | undefined,
  configured: string | undefined,
  mode: string | undefined,
): string {
  if (hostname === LIVE_HUB_HOST) return 'production';
  return configured || mode || 'production';
}
